import { useContext } from "react";
import { MembersContext } from "../contexts/MembersContext";

/**
 * useMembers
 *
 * Hook para acessar o cache centralizado de membros.
 * Retorna a lista completa + refresh para forçar recarga.
 *
 * Uso:
 *   const { members, loading, refresh } = useMembers();
 */
export const useMembers = () => {
    const context = useContext(MembersContext);
    if (!context) {
        throw new Error("useMembers deve ser usado dentro de um MembersProvider");
    }
    return context;
};
